import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Select,Input,ChakraProvider,
  HStack,Switch,FormLabel, FormControl,Tooltip,Box,
  Textarea
} from "@chakra-ui/react";

import { useNavigate } from "react-router-dom";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import logout from "../../services/authService";
import { useSession } from "../../SessionContext";
import { createEmailMessage, getEmailMessage, initSurveyService } from "../../services/http/surveyHttpService";
import { createSurveyADP } from "../../services/http/surveyHttpService";
import { getExpertsGroupsADP } from "../../services/http/surveyHttpService";
import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { saveSurveyDraftADP } from "../../services/http/surveyHttpService";
import DatePicker from "react-datepicker";
import { extendTheme } from '@chakra-ui/react';
import "react-datepicker/dist/react-datepicker.css";  // Import the CSS for datepicker
import { useTranslation } from "react-i18next";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const themeDatePicker = extendTheme({
  components: {
    Input: {
      baseStyle: {
        field: {
          fontSize: 'lg',
          padding: '12px',
        },
      },
    },
  },
});
const SaveUpdateSurveyModal = ({ isOpen, onClose, surveyStructure , isDraft , updateFormData }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const {t} = useTranslation();
  const [isOptional, setIsOptional] = useState(false);
  const toast = useToast();
    const [pageNum, setPageNum] = useState(0);
    const [createNewEmailMessage, setCreateNewEmailMessage] = useState(false);
    const [emailMessages, setEmailMessages] = useState([]);
    const [emailMessageTextReadOnly, setEmailMessageTextReadOnly] = useState("");
  
    const [payloadCreateEmailMessage, setPayloadCreateEmailMessage] = useState({});

  const { updateSessionData, clearSessionData} = useSession();
  const navigate = useNavigate();
  let axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
    
  });

  initSurveyService(t, toast, axiosInstance)


  const [expertGroup, setExpertGroup] = useState(""); // Stato per il gruppo esperti
  const [surveyType, setSurveyType] = useState(""); // Stato per la tipologia
  const [messageId, setMessageId] = useState("");

  const [expertGroups, setExpertGroups] = useState([
  ]); // Stato per il gruppo esperti


  const [surveyTypes] = useState(["public", "private"]); // Stato per la tipologia


  const handleExpertGroupChange = (e) => setExpertGroup(e.target.value);
  const handleSurveyTypeChange = (e) => setSurveyType(e.target.value);

  useEffect(() => { 
    
 console.log(updateFormData)

 if(updateFormData != null) {
  if(updateFormData.type != null)  
    setSurveyType(updateFormData.type)
  if(updateFormData.experts_group != null)  
    setExpertGroup(updateFormData.experts_group)
   
  }
    
    
 getExpertsGroupsADP(sessionStorage.getItem("username")).then(res => {


        if(res != null && res.expertsGroups != null && res.expertsGroups.length >0)

        setExpertGroups(res.expertsGroups)
    })

    getEmailMessage(t, { username: sessionStorage.getItem("username"), is_consensus: false}).then(
      (res) => {
        console.log("Get Email Message", res);

        if(res.columns.length === 0) {
          setCreateNewEmailMessage(true)
        }else {

        setEmailMessages(res.columns);
        setEmailMessageTextReadOnly(res.columns[0].message_text)
        setMessageId(res.columns[0].message_id);
      
      }
      }
    );

  }, []);
 


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered closeOnOverlayClick={false} >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
        {isDraft && (
              t('survey.saveUpdateModalSurvey.updateSurveyDraft')
            )}

            {!isDraft && (
              t('survey.saveUpdateModalSurvey.saveSurveyDraft')
            )}

        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>

        {pageNum === 0 && (
            <>
        <FormControl mb={"5%"}>
        <FormLabel fontWeight="bold" mb={2}>
        Select Survey Type
  </FormLabel>
        <Select
              placeholder="Select Survey Type"
              value={surveyType}
              onChange={handleSurveyTypeChange}
            >
              {surveyTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </Select>
            </FormControl>


        <FormControl>
        <HStack align="center" spacing={4}>
          {/* Switch */}
       
          
          {isDraft && (
  <Box>
    {/* Tooltip che avvolge lo Switch */}
    <Tooltip label="Toggle to select group of experts" aria-label="Switch tooltip">
      <FormLabel htmlFor="isOptional" mb="0">
        <Switch
          id="isOptional"
          isChecked={isOptional}
          onChange={() => setIsOptional(!isOptional)}
          colorScheme="teal"
        />
      </FormLabel>
    </Tooltip>
  </Box>
)}

          {/* Select */}
          { !isDraft && pageNum == 0 &&(

            
<FormControl>
<FormLabel fontWeight="bold" mb={2}>
Select Expert Group
</FormLabel>
            <Select
              placeholder="Select Expert Group"
              value={expertGroup}
              onChange={handleExpertGroupChange}
            >
              {expertGroups.map((group) => (
                <option key={group.expert_group_id} value={group.title}>
                  {group.title}
                </option>
              ))}
            </Select></FormControl>
          


          
          )}





{isOptional  && (
  <FormControl mb={2}>
  <FormLabel fontWeight="bold" mb={2}>
  Select Expert Group
  </FormLabel>
            <Select
              placeholder="Select Expert Group"
              value={expertGroup}
              onChange={handleExpertGroupChange}
            >
              {expertGroups.map((group) => (
                <option key={group.expert_group_id} value={group.title}>
                  {group.title}
                </option>
              ))}
            </Select></FormControl>
          )}

        </HStack>
      </FormControl>
      <ChakraProvider theme={themeDatePicker}>
   
      <FormControl mt={6}>
          <FormLabel  mb={2}>Select Date and Time</FormLabel>
          <DatePicker
            selected={selectedDate}
            onChange={(date)=>   setSelectedDate(date)}
           
            dateFormat="dd/MM/yyyy" // Shows both Date and Time
              
            customInput={<Input />}
            placeholderText="Select a date"
          />
        </FormControl>
        
        </ChakraProvider>
        </>)}


        {pageNum === 1 && (
            <>

            {emailMessages && emailMessages.length > 0 && (

                  <FormControl display="flex" alignItems="center">
                  <FormLabel mb={2}>Create New Email Message</FormLabel>
                  <Switch
                    id="email-alerts"
                    onChange={(e) => {
                      setCreateNewEmailMessage(e.target.checked);
                    }}
                  />
                </FormControl>
              )}
            

              {!createNewEmailMessage && (
                <>
                  <FormControl mt={4}>
                    <FormLabel>Email Messages</FormLabel>
                    <Select
                      onChange={(e) => {
                       // handleChange(e, "message_id");
                       let message_id = e.target.value;
                       setMessageId(message_id)
                       setEmailMessageTextReadOnly( emailMessages.find(email => email.message_id === message_id).message_text)

                      }}
                    >
                      {emailMessages.map((option) => (
                        <option
                          key={option.message_id}
                          value={option.message_id}
                        >
                          {option.title}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl mt={4}>
                    <FormLabel
                      fontSize="lg"
                      color="rgba(11,78,90,255)"
                      fontWeight="semibold"
                    >
                      Email Message:
                    </FormLabel>
                    <Textarea
                      placeholder="Email Message"
                      minH="250px" // Altezza minima di 500px
                      maxH="260px"
                      overflowY="auto" // Abilita lo scrolling verticale
                      resize="vertical" // Permette il ridimensionamento verticale
                      isReadOnly
                      value={emailMessageTextReadOnly}
                    />
                  </FormControl>
                </>
              )}

              {createNewEmailMessage && (
                <>
                   <FormControl isRequired>
                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>Title Email Message</FormLabel>
                    <Input value={payloadCreateEmailMessage.title} onChange={(e)=> {   setPayloadCreateEmailMessage({ ...payloadCreateEmailMessage, title: e.target.value });
                    }} variant='filled' placeholder='Title Email Message' name='Title Email Message' type='text' bg='white'/>
                    </FormControl>

                  <FormControl mt={4}>
                    <FormLabel
                      fontSize="lg"
                      color="rgba(11,78,90,255)"
                      fontWeight="semibold"
                    >
                      Email Message:
                    </FormLabel>
                    <Textarea
                      value={payloadCreateEmailMessage.message_text}
                      placeholder="Email Message"
                      minH="250px" // Altezza minima di 500px
                      maxH="260px"
                      overflowY="auto" // Abilita lo scrolling verticale
                      resize="vertical" // Permette il ridimensionamento verticale
                      onChange={(e) =>  setPayloadCreateEmailMessage({ ...payloadCreateEmailMessage, message_text: e.target.value })}
                      
                    />
                  </FormControl>
                </>
              )}
            </>
          )}



        </ModalBody>
        <ModalFooter>
{pageNum == 0 && !isDraft && (
            <Button
              rightIcon={<ChevronRightIcon />}
              colorScheme="blue"
              onClick={() => {
                setPageNum(1);
              }}
            >
              Next
            </Button>
          )}

          {pageNum == 1 && !isDraft  && (
            <Button
              mr={"4%"}
              leftIcon={<ChevronLeftIcon />}
              colorScheme="blue"
              onClick={() => {
                setPageNum(0);
              }}
            >
              Back
            </Button>
          )}
   {(isDraft || pageNum === 1) && (

          <Button
            colorScheme="blue"
            onClick={async () => {
              async function call(bodyReqSaveSurvey) {
                if (updateFormData != null && updateFormData.id_survey_info != null) {
                  bodyReqSaveSurvey.id_survey_info = updateFormData.id_survey_info;
                }
            
                // Logica per impostare expert_group_id
                if (isDraft) {
                  if (isOptional && expertGroup) {
                    const selectedExpertGroup = expertGroups.find(
                      (expertGroupRes) => expertGroupRes.title === expertGroup
                    );
                    if (selectedExpertGroup) {
                      bodyReqSaveSurvey.expert_group_id = selectedExpertGroup.expert_group_id;
                    }
                  }
                } else if (expertGroup) {
                  const selectedExpertGroup = expertGroups.find(
                    (expertGroupRes) => expertGroupRes.title === expertGroup
                  );
                  if (selectedExpertGroup) {
                    bodyReqSaveSurvey.expert_group_id = selectedExpertGroup.expert_group_id;
                  }

                  selectedDate.setUTCDate(selectedDate.getUTCDate() + 1);

                  // Aggiungi un'ora
                  selectedDate.setUTCHours(selectedDate.getUTCHours() + 1);
            
                  bodyReqSaveSurvey.end_date = selectedDate.toISOString();
                }
            
                console.log(bodyReqSaveSurvey);
            
                // Effettua la chiamata API corretta
                if (isDraft) {
                  if (bodyReqSaveSurvey.type) {
                    await saveSurveyDraftADP(bodyReqSaveSurvey);
                    navigate("/surveys?hideHeader=true&hideNavbar=true");
                  } else {
                    toast({
                      title: t("toastMsg.saveSurveyModal.insertFieldSurveyType"),
                      status: "error",
                      duration: 3000,
                      isClosable: true,
                    });
                    return;
                  }
                } else {
                  if (bodyReqSaveSurvey.type && bodyReqSaveSurvey.expert_group_id) {
                    await createSurveyADP(bodyReqSaveSurvey);
                    navigate("/surveys?hideHeader=true&hideNavbar=true");
                  } else {
                    toast({
                      title: t("toastMsg.saveSurveyModal.insertFieldExpertGroupAndSurveyType"),
                      status: "error",
                      duration: 3000,
                      isClosable: true,
                    });
                    return;
                  }
                }
            
                toast({
                  title: t("toastMsg.saveSurveyModal.surveySavedSuccessfully"),
                  status: "success",
                  duration: 3000,
                  isClosable: true,
                });
            
                onClose();
              }
            
              try {
                let messageIdLocal = messageId; // Variabile locale per evitare il problema di setState
            
                if (createNewEmailMessage) {
                  if (payloadCreateEmailMessage.title && payloadCreateEmailMessage.message_text) {
                    payloadCreateEmailMessage.owner = sessionStorage.getItem("username");
                    payloadCreateEmailMessage.is_consensus = false;
            
                    try {
                      const res = await createEmailMessage(t, payloadCreateEmailMessage);
                      if (res && res.message_id) {
                        messageIdLocal = res.message_id; // Aggiorna la variabile locale
                        setMessageId(res.message_id); // Aggiorna lo stato (asincrono)
                      }
                    } catch (error) {
                      toast({
                        title: "Errore nella creazione del messaggio email",
                        description: error.message || "",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                      });
                      return;
                    }
                  } else {
                    toast({
                      title: "Errore Campi Mancanti Nella Creazione Messaggio Email",
                      description: "",
                      status: "warning",
                      duration: 4000,
                      isClosable: true,
                    });
                    return;
                  }
                }
            
                let bodyReqSaveSurvey = {
                  owner: sessionStorage.getItem("username"),
                  type: surveyType,
                  survey_structure: surveyStructure,
                  expert_group_id: null,
                  message_id: messageIdLocal, // Usa la variabile locale che ha il valore corretto
                };
            
                await call(bodyReqSaveSurvey);
              } catch (error) {
                console.error("Error saving survey:", error);
                toast({
                  title: t("toastMsg.saveSurveyModal.failedToSaveSurvey"),
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                });
              }
            }}
            
            
            
          >
            {isDraft && (
              t('survey.saveUpdateModalSurvey.updateAndClose')
            )}

            {!isDraft && (
              t('survey.saveUpdateModalSurvey.saveAndClose')
            )}
          </Button>)}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaveUpdateSurveyModal;
